import styled from 'styled-components';

export const Container = styled.div`
  background-color: #ffffff;
  @media (max-width: 768px) {
    display: none;
  }
`;
